import React, {Suspense, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ReactPixel from 'react-facebook-pixel';
import GlobalStyle from './globalStyles';
import './App.style';
import styled from 'styled-components';
import './i18next';
import Spinner from './features/spinner/Spinner';
import Router from './Router';
import Error from './features/error/Error';
import Note from './features/note/Note';
import { tabletWidth } from './mixins';
import { FB_PIXEL_ID } from './analytics/facebook';
import {selectUserID} from './features/auth/authSlice';
import Cookies from 'js-cookie';
import {selectPseudoFlow, setAppDomain} from './features/onboarding/onboardingSlice';


const StyledWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 0 auto; 
  display: flex;
  flex-direction: column;
  align-items: center;
  &::-webkit-scrollbar {
  display: none;
  }
  
  @media screen and (max-width: ${tabletWidth}) {
     height: calc(var(--vh, 1vh) * 100);
  }
  
  @media screen and (min-width: ${tabletWidth}) {
   overflow-y: auto;
  }
`;

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);


const App = () => {
    const userID = useSelector(selectUserID);
    const AFUserID = Cookies.get('afUserId');
    const externalId = useMemo(() => [AFUserID,userID],[AFUserID,userID]);
    const dispatch = useDispatch();
    const isPseudoFlow = useSelector(selectPseudoFlow);
    useEffect(() => {
        window.scrollTo(0,1);
        !isPseudoFlow && dispatch(setAppDomain(window.location.href));
    }, [isPseudoFlow]);

    useEffect(() => {
        ReactPixel.init(FB_PIXEL_ID,{'external_id': externalId});
        ReactPixel.pageView();
    }, [externalId]);

    return (
        <Suspense fallback={<Spinner suspenseShow={true}/>}>
            <StyledWrapper>
                <GlobalStyle/>
                <Router/>
                <Error/>
                <Note/>
                <Spinner/>
            </StyledWrapper>
        </Suspense>

    );
};

export default App;